import {
  loadState,
  saveState
} from '@/solaris-lens-common-lib-web/src/utils/localStorage';

import { LEFT_PANEL_WIDTH_STORAGE_KEY } from './panelResizeConstants';

export function loadSavedLeftPanelWidth(): number | null {
  const value = loadState(LEFT_PANEL_WIDTH_STORAGE_KEY);

  if (typeof value !== 'number' || !Number.isFinite(value)) {
    return null;
  }

  return value;
}

export function saveLeftPanelWidth(width: number) {
  saveState(width, LEFT_PANEL_WIDTH_STORAGE_KEY);
}
